export default __webpack_public_path__ + "static/media/slogan1.8b0f2e0d.png";